import DefaultLayout from '../../Layouts/DefaultLayout';
import { lazy } from 'react';
import { LoginRoutes } from '@/features/auth/routes/routes';
import { AuthInitializer } from '@/features/auth/guard/authInitializer';
import { CustomerRealtionsRoutes } from '@/features/customerRelations/routes/routes';
import { OrderListRoutes } from '@/features/orders/routes/routes';
import { ServiceListRoutes } from '@/features/services/routes/routes';
import { HumanResourcesRoutes } from '@/features/humanResources/routes/routes';
import { BranchesRoutes } from '@/features/branch/routes/routes';
import { SettingRoutes } from '@/features/setting/routes/routes';
import { PermissionsRoutes } from '@/features/permissions/routes/routes';
import { ReportsRoutes } from '@/features/reports/routes/routes';
import { ProductsListRoutes } from '@/features/products/routes/routes';
import { SubscriptionsRoutes } from '@/features/subscriptions/routes/routes';
import { FinanceRoutes } from '@/features/finance/routes/routes';
import { NotificationsRoutes } from '@/features/notifications/routes/routes';
import { CustomerByTypeRoutes } from '@/features/customers_by_type/routes/routes';
import { RouteErrorPage } from '@repo/ui/components/errors';

// ----------------------------------------------------------------------

const Home = lazy(() => import('@/core/global-pages/Home'));
const SoonPage = lazy(() => import('@/core/global-pages/SoonPage'));
const NotFound = lazy(() => import('@/core/global-pages/NotFound'));
const ServerError = lazy(() => import('@/core/global-pages/ServerError'));

// ----------------------------------------------------------------------

const routes = [
    {
        path: '/',
        element: (
            <AuthInitializer>
                <DefaultLayout />
            </AuthInitializer>
        ),
        errorElement: <RouteErrorPage />,
        children: [
            { index: true, element: <Home /> },
            {
                path: '/coming-soon',
                element: <SoonPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: '/500',
                element: <ServerError />,
                layout: 'default',
                isAuthReq: true,
            },

            ...CustomerRealtionsRoutes,
            ...OrderListRoutes,
            ...ServiceListRoutes,
            ...HumanResourcesRoutes,
            ...BranchesRoutes,
            ...SettingRoutes,
            ...PermissionsRoutes,
            ...ReportsRoutes,
            ...ProductsListRoutes,
            ...SubscriptionsRoutes,
            ...FinanceRoutes,
            ...NotificationsRoutes,
            ...CustomerByTypeRoutes,
            { path: '*', element: <NotFound /> },
        ],
    },
    ...LoginRoutes,
    { path: '/500', element: <ServerError />, errorElement: <RouteErrorPage /> },
    { path: '*', element: <NotFound />, errorElement: <RouteErrorPage /> },
];
export { routes };
